module.exports = __webpack_public_path__ + "img/pay-paypal.a646884.png";